"use client";

import { cn } from "@repo/ui/lib/utils";
import { InView } from "react-intersection-observer";
import { useScramble } from "use-scramble";

type ScramblerProps = {
  children: string;
  className?: string;
  containerClassName?: string;
  triggerOnce?: boolean;
  as?: "div";
  overflow?: boolean;
  overdrive?: boolean;
  speed?: number;
};

export const Scrambler = ({
  children,
  className,
  containerClassName,
  triggerOnce = false,
  as = "div",
  overflow = true,
  overdrive = false,
  speed = 0.4,
}: ScramblerProps) => {
  const { ref, replay } = useScramble({
    text: children,
    overdrive: overdrive,
    playOnMount: false,
    overflow,
    speed,
    scramble: 2,
    tick: 1,
    range: [97, 122],
  });

  return (
    <InView as={as} onChange={(inView) => inView && replay()} className={containerClassName} triggerOnce={triggerOnce}>
      <button onMouseEnter={replay} className={cn(className, "font-code")} ref={ref} type="button" />
    </InView>
  );
};
